import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { useState, useEffect } from 'react';

const OfflineNotification = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

      if (isOnline) return null;

    return (
        <div className='fixed bottom-0 mb-4 z-[200] w-full pt-1 flex justify-center items-center'>
            <div className='w-11/12 md:w-5/6 p-3 z-[200] flex bg-destructive text-destructive-foreground rounded-md justify-center items-center h-fit'>
                <ExclamationTriangleIcon className="mr-3 size-6 md:size-4" />
                <span>Du är för närvarande offline. Vissa funktioner fungerar inte.</span>
            </div>
        </div>
    );
};

export default OfflineNotification;